import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { RouterService } from 'core/services/router.service';
import { StorageService } from 'core/services/storage.service';

export const UnAuthGuard: CanActivateFn = () => {
  const storageService = inject(StorageService);
  const routerService = inject(RouterService);

  const { isAuthenticated } = storageService;

  // if (isAuthenticated) {
  //   const defaultRoute = storageService.getDefaultAuthRoute();
  //   if(defaultRoute){
  //     routerService.navigate(defaultRoute);
  //   }else{
  //     storageService.clearStorage();
  //     routerService.goToLogin();
  //   }
  // }

  // return !isAuthenticated;

  return true;
};
